module.exports = __webpack_public_path__ + "img/study-2.12633ad7.svg";